/*eslint-disable*/ export const messages = {
    Apply: "Применить",
    "Changed the date": "Дата изменена",
    Clear: "Очистить",
    "Date picker open, choose a date": "Средство выбора даты открыто, выберите дату",
    "Date range picker open, select a date range": "Средство выбора диапазона дат открыто, выберите диапазон дат",
    "End Date": "Дата окончания",
    "Please enter a valid date ({format})": ["Введите дату (", ["format"], ")"],
    "Please select a date after {minDate}": ["Выберите дату после ", ["minDate"]],
    "Please select a date before {maxDate}": ["Выберите дату до ", ["maxDate"]],
    "Show next month": "Показать следующий месяц",
    "Show previous month": "Показать предыдущий месяц",
    "Start Date": "Дата начала",
    "The selected date is disabled": "Выбранная дата отключена",
    "The selected date is unavailable. Please select another.": "Выбранная дата недоступна. Выберите другое значение.",
    Today: "Сегодня",
    "Today, {dateStr}": ["Сегодня, ", ["dateStr"]],
    "date picker": "средство выбора даты",
    "start date selected": "выбрана начальная дата",
    to: "по",
    "{dateStr}, select end date": [["dateStr"], ", выберите конечную дату"],
    "{dateStr}, select start date": [["dateStr"], ", выберите начальную дату"],
    "{startDate} to {endDate}, choose apply to confirm, or cancel": [
        ["startDate"],
        "–",
        ["endDate"],
        ', выберите "Применить" для подтверждения или нажмите "Отмена"',
    ],
};
